import React from "react";
import { FormFieldLabel } from "../../../atoms/proc-management/form";
import { InputNoticeList } from "./input-notice-list";
import type { InputProps } from "./types";

const notices = [
  "手続きを一意に特定するためのidです。作成時に自動で付与されるため、編集することはできません。",
];

type Props = Omit<InputProps, "onChange"> & { value: string };

export const ProcedureIdInput: React.FC<Props> = ({
  disabled = false,
  value,
}) => {
  return (
    <div className="field mb-6">
      <FormFieldLabel label="手続きID" />
      <InputNoticeList notices={notices} />
      <div className="control">
        <input className="input" value={value} disabled={disabled} />
      </div>
    </div>
  );
};
